import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { roleHome } from "@/lib/constants";
import { Spinner } from "@/components/ui-bits";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const clean = () => window.history.replaceState(null, "", window.location.pathname);
    if (!match) { clean(); navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: decodeURIComponent(match[1]) });
        setUser(data.user);
        clean();
        toast.success(`Welcome, ${data.user.name.split(" ")[0]}`);
        navigate(roleHome(data.user), { replace: true });
      } catch (err) {
        clean();
        toast.error(apiError(err, "This Google account isn't registered."));
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center">
        <Spinner className="text-primary w-8 h-8" />
        <p className="text-sm text-muted-foreground mt-4">Signing you in…</p>
      </div>
    </div>
  );
}
